import { EntityConfig } from './entity-registry';
import { GenericTableColumn, GenericTableAction } from '../../../../../models/GenericCRUD/GenericTable';
import { GenericFormField } from '../../../../../models/GenericCRUD/GenericForm';
import { Filter } from '../../../../../models/GenericCRUD/Filter';

const tableColumns: GenericTableColumn[] = [
  { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
  { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
  { name: 'Sociedad', active: true, type: 'text', key: 'company.name', sort: true },
  { name: 'Activo', active: true, type: 'boolean', key: 'active', sort: true }
];

const formFields: GenericFormField[] = [
  { name: 'name', type: 'text', label: 'Nombre del TPV', validations: 'required', colspan: 2 },
  { name: 'company_id', type: 'select', label: 'Sociedad', validations: 'required', url: '/config/company/listAll', singleSelection: true, colspan: 1 },
  { name: 'active', type: 'boolean-switch', label: 'Activo', validations: '', colspan: 1 }
];

const formFieldsEdit: GenericFormField[] = [
  { name: 'name', type: 'text', label: 'Nombre del TPV', validations: 'required', colspan: 2 },
  { name: 'company_id', type: 'select', label: 'Sociedad', validations: 'required', url: '/config/company/listAll', singleSelection: true, colspan: 1 },
  { name: 'active', type: 'boolean-switch', label: 'Activo', validations: '', colspan: 1 }
];

const tableActions: GenericTableAction[] = [
  {
    name: 'Editar',
    key: 'edit',
    form: {
      method: 'PUT',
      successTitle: 'TPV editado correctamente',
      errorTitle: 'Error al editar TPV',
      fields: formFieldsEdit,
      name: 'pos-terminal',
      createButtonTitle: '',
      cols: 2,
      createApiSlug: '',
      originalUpdateApiSlug: '/config/pos-terminal/update/{{id}}',
      updateApiSlug: '',
      originalFormTitle: 'Editar {{name}}',
      formTitle: 'Editar TPV',
      formButtonTitle: 'Guardar cambios',
      width: '3xl'
    },
    completeForm: true,
    replaceAllRowOnResponse: true,
    icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" /><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" /><path d="M16 5l3 3" /></svg>',
    confirmation: false
  },
  {
    name: 'Eliminar',
    key: 'delete',
    method: 'DELETE',
    icon: '<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
    confirmation: true,
    questionText: '¿Desea eliminar este TPV?',
    deleteRowOnResponse: true,
    actionSlug: '/config/pos-terminal/delete/{{id}}'
  }
];

const filters: Filter[] = [
  { type: 'search', key: 'name', operator: 'like', placeholder: 'Nombre del TPV' },
  { type: 'multiselect', key: 'company.name', operator: 'in', placeholder: 'Sociedad', url: '/config/company/listAll', relation_filter_column: 'company_id' }
];

/**
 * POS Terminal entity configuration
 */
export const posTerminalConfig: EntityConfig = {
  id: 'pos-terminals',
  name: 'TPVs',
  icon: '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"/></svg>',

  tableColumns,
  formFields,
  formFieldsEdit,
  tableActions,
  filters,

  form: {
    successTitle: 'TPV creado correctamente',
    errorTitle: 'Error al crear TPV',
    method: 'POST',
    fields: formFields,
    name: 'pos-terminal',
    createButtonTitle: 'Nuevo TPV',
    cols: 2,
    createApiSlug: '/config/pos-terminal/store',
    formTitle: 'Crear TPV',
    formButtonTitle: 'Crear TPV',
    width: '3xl'
  },

  table: {
    columns: tableColumns,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/pos-terminal/index',
    paginate: true,
    name: 'pos-terminals',
    actions: tableActions
  },

  useModalForm: true
};
